import style from './style.module.scss'
import { Header, Text } from '@crossfit/design-system'
import { useAffiliate } from 'hooks/useAffiliate'
import { useSelector } from 'react-redux'
import { getAffiliate } from 'store/selectors'

export const Desktop = () => {
  const { selectedAffiliate: affiliate } = useAffiliate()
  const affiliateDetail = useSelector(getAffiliate)
  return (
    <div className={style.container}>
      <Text
        as='label'
        type='overline'
        size='xs'
        bold
        className={style.subHeader}
      >
        {'Manage My Affiliate'}
      </Text>
      <div className={style.affiliateContainer}>
        {affiliateDetail.images?.logo?.url ? (
          <img
            className={style.affiliateLogo}
            src={affiliateDetail.images.logo.url}
          />
        ) : null}
        <Header as='h1' size='md' className={style.header}>
          {affiliate.name}
        </Header>
      </div>
    </div>
  )
}
